type Row = { feature: string; gas: string | boolean; solar: string | boolean; whole: string | boolean };

const rows: Row[] = [
  { feature: "Fuel Required", gas: "Gasoline", solar: "None / Solar", whole: "Natural Gas / Propane" },
  { feature: "Noise Level", gas: "Loud", solar: "Silent", whole: "Low" },
  { feature: "Maintenance", gas: "Regular", solar: "Low", whole: "Professional Annual" },
  { feature: "Indoor Use", gas: false, solar: true, whole: false },
  { feature: "Expandability", gas: "Limited", solar: "Excellent", whole: "Limited" },
  { feature: "Installation Cost", gas: "Low", solar: "Moderate", whole: "High" },
];

function Cell({ value }: { value: string | boolean }) {
  if (typeof value === "boolean") {
    return value ? (
      <span className="inline-flex w-6 h-6 items-center justify-center bg-emerald-100 rounded-full">
        <i className="ri-check-line text-emerald-600 text-sm"></i>
      </span>
    ) : (
      <span className="inline-flex w-6 h-6 items-center justify-center bg-red-100 rounded-full">
        <i className="ri-close-line text-red-500 text-sm"></i>
      </span>
    );
  }
  return <span className="text-sm text-gray-700">{value}</span>;
}

export default function ComparisonTable() {
  return (
    <section id="compare" className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Compare Backup Power Options
          </h2>
          <p className="text-gray-500 mt-3 text-base max-w-xl mx-auto">
            Not every backup system is built the same. Here&apos;s the clear breakdown.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="py-4 px-5 text-left text-gray-500 font-semibold text-xs uppercase tracking-wider w-40">Features</th>
                <th className="py-4 px-5 text-center">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full">
                      <i className="ri-oil-line text-gray-600 text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 text-sm">Gas Generator</span>
                  </div>
                </th>
                <th className="py-4 px-5 text-center bg-amber-50">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full">
                      <i className="ri-sun-line text-amber-500 text-lg"></i>
                    </div>
                    <span className="font-bold text-amber-700 text-sm">Solar Generator</span>
                    <span className="text-[10px] bg-amber-500 text-white px-2 py-0.5 rounded-full font-semibold">Most Popular</span>
                  </div>
                </th>
                <th className="py-4 px-5 text-center">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full">
                      <i className="ri-building-2-line text-gray-600 text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 text-sm">Whole Home Standby</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={`border-b border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}`}>
                  <td className="py-4 px-5 font-semibold text-gray-700 text-sm">{row.feature}</td>
                  <td className="py-4 px-5 text-center"><Cell value={row.gas} /></td>
                  <td className="py-4 px-5 text-center bg-amber-50/50"><Cell value={row.solar} /></td>
                  <td className="py-4 px-5 text-center"><Cell value={row.whole} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center text-gray-400 text-xs mt-5">
          Why Solar Backup Beats Gas Generators — A continuous, reliable, clean energy solution with no fuel storage, no fumes, no maintenance.
        </p>
      </div>
    </section>
  );
}
